// flickety slider home page custom code

document.addEventListener('DOMContentLoaded', () => {
  const elem = document.querySelector('#custom_flickity_article');
  // if (elem) return;
  let flkty = null;

  const toggleFlickity = () => {
    if (window.innerWidth <= 768) {
      if (!flkty) flkty = new Flickity(elem, {
          wrapAround: true,
          pageDots: true,
          initialIndex: 0,
          accessibility: true,
          autoPlay: false,
          prevNextButtons: false,
          cellAlign: 'left',
          contain: false
        });

    } else {
      if (flkty) {
        flkty.destroy();
        flkty = null;
      }
    }
  };

  toggleFlickity();
  window.addEventListener('resize', toggleFlickity);

// flickety slider home page custom code end

// cart drawer delete icon custom code


  // document.addEventListener('click', async e => {
  //   const btn = e.target.closest('.cart-remove-btn');
    
  //   if (!btn) return;

  //   e.preventDefault();

  //   const key = btn.dataset.lineKey;
  //   if (!key) return;

  //   const item = btn.closest('.cart-item, .drawer__cart-item, .cart__item');
  //   if (item) {
  //     item.style.transition = 'opacity 0.3s ease';
  //     item.style.opacity = '0';
  //     setTimeout(() => item.remove(), 300);
  //   }

  //   try {
  //     const res = await fetch('/cart/update.js', {
  //       method: 'POST',
  //       headers: { 'Content-Type': 'application/json' },
  //       body: JSON.stringify({ updates: { [key]: 0 } })
  //     });
  //     const cart = await res.json();


  //     document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { cart } }));
  //     document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart } }));

  //     const drawer = document.querySelector('#CartDrawer');
  //     if (drawer) {
  //       drawer.classList.add('drawer--is-open');
  //       drawer.classList.toggle('is-empty', cart.item_count === 0);
  //     }

  //     const sectionsRes = await fetch('/?sections=cart-drawer,cart-icon-bubble');
  //     const sections = await sectionsRes.json();

  //     if (drawer && sections['cart-drawer']) {
  //       const newDrawerInner = new DOMParser()
  //         .parseFromString(sections['cart-drawer'], 'text/html')
  //         .querySelector('#CartDrawer').innerHTML;

  //       drawer.innerHTML = newDrawerInner;
  //       drawer.classList.add('drawer--is-open');
  //       drawer.classList.toggle('is-empty', cart.item_count === 0);
  //     }

  //     const bubble = document.querySelector('.cart-icon-bubble');
  //     if (bubble && sections['cart-icon-bubble']) {
  //       const newBubbleInner = new DOMParser()
  //         .parseFromString(sections['cart-icon-bubble'], 'text/html')
  //         .querySelector('.cart-icon-bubble').innerHTML;
  //       bubble.innerHTML = newBubbleInner;
  //     }

  //   } catch (err) {
  //     console.error('Remove failed:', err);
  //   }
  // });

// cart drawer delete icon custom code end



// document.addEventListener('click', async e => {
//   const btn = e.target.closest('.cart-featured-collection__add');
//   if (!btn) return;

//   e.preventDefault();

//   const variantId = btn.dataset.variantId;
//   if (!variantId) return;

//   btn.disabled = true;
//   const oldText = btn.textContent;
//   btn.textContent = 'Adding...';

//   try {
//     const res = await fetch('/cart/add.js', {
//       method: 'POST',
//       headers: { 'Content-Type': 'application/json' },
//       body: JSON.stringify({ id: variantId, quantity: 1 })
//     });

//     const addedItem = await res.json();
    
//     const cartRes = await fetch('/cart.js');
//     const cart = await cartRes.json();
    
//   document.dispatchEvent(new CustomEvent('cart:build', { detail: { cart } }));

//     const drawer = document.querySelector('#CartDrawer');
//     if (drawer) {
//       drawer.classList.add('drawer--is-open');
//       drawer.classList.toggle('is-empty', cart.item_count === 0);
//     }

//     const sectionsRes = await fetch('/?sections=cart-drawer,cart-icon-bubble');
//     const sections = await sectionsRes.json();

//     if (drawer && sections['cart-drawer']) {
//       const newDrawerInner = new DOMParser()
//         .parseFromString(sections['cart-drawer'], 'text/html')
//         .querySelector('#CartDrawer').innerHTML;

//       drawer.innerHTML = newDrawerInner;
//       drawer.classList.add('drawer--is-open');
//       drawer.classList.toggle('is-empty', cart.item_count === 0);
//     }

//     const bubble = document.querySelector('.cart-icon-bubble');
//     if (bubble && sections['cart-icon-bubble']) {
//       const newBubbleInner = new DOMParser()
//         .parseFromString(sections['cart-icon-bubble'], 'text/html')
//         .querySelector('.cart-icon-bubble').innerHTML;

//       bubble.innerHTML = newBubbleInner;
//     }

//     btn.textContent = 'Add';
//     setTimeout(() => {
//       btn.textContent = oldText;
//       btn.disabled = false;
//     }, 500);

//   } catch (err) {
//     console.error('Add failed:', err);
//     btn.textContent = 'Error';
//     setTimeout(() => {
//       btn.textContent = oldText;
//       btn.disabled = false;
//     }, 500);
//   }
// });

// document.addEventListener('DOMContentLoaded', () => {
//   const menu = document.querySelector('[data-menu]');
//   if (!menu) return;

//   menu.addEventListener('click', e => {
//     const openBtn = e.target.closest('[data-open]');
//     const backBtn = e.target.closest('[data-back]');

//     if (openBtn) {
//       const target = openBtn.dataset.open;
//       menu.querySelector('.menu-screen.is-active')
//         .classList.remove('is-active');
//       menu.querySelector(`[data-screen="${target}"]`)
//         .classList.add('is-active');
//     }

//     if (backBtn) {
//       menu.querySelector('.menu-screen.is-active')
//         .classList.remove('is-active');
//       menu.querySelector('[data-screen="root"]')
//         .classList.add('is-active');
//     }
//   });
// });


document.addEventListener('click', async e => {
    const btn = e.target.closest('.cart-remove-btn');
    
    if (!btn) return;
    e.preventDefault();
    const cartDrawer = document.querySelector("#CartDrawer");
    cartDrawer.classList.add("cart-loader");
    const key = btn.dataset.lineKey;
    if (!key) return;

    const item = btn.closest('.cart-item, .drawer__cart-item, .cart__item');
    if (item) {
      item.style.transition = 'opacity 0.3s ease';
    }

    try {
      const res = await fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ updates: { [key]: 0 } })
      });
      const cart = await res.json();

      if(__st.p == 'cart'){
        location.reload();
      }else{
        document.dispatchEvent(new CustomEvent('ajaxProduct:added'));
      }
      const bubble = document.querySelector('.cart-icon-bubble');
      if (bubble && sections['cart-icon-bubble']) {
        const newBubbleInner = new DOMParser()
          .parseFromString(sections['cart-icon-bubble'], 'text/html')
          .querySelector('.cart-icon-bubble').innerHTML;
        bubble.innerHTML = newBubbleInner;
      }
      if(cart.items.length == 0){
          localStorage.setItem('recently_added_variant','');
      }
      if(cart.items.length){
        let total_boquet_count = 0;
        cart.items.forEach((d_item)=>{
          if(d_item.product_type == 'Bouquets'){
            total_boquet_count+=1;
          }
        })
        if(total_boquet_count == 0){
          localStorage.setItem('recently_added_variant','');
        }
      }
      cartDrawer.classList.remove("cart-loader");
      if(btn && btn.closest('.cart__item') && btn.closest('.cart__item').dataset.type == 'Bouquets'){
        window.show_bouquet_upsell_popup();
      }
      await update_cart_attr_bush_count();
    } catch (err) {
      cartDrawer.classList.remove("cart-loader");
      console.error('Remove failed:', err);
    }
  });
});

document.addEventListener('keydown', e => {
  if (
    e.key === 'Enter' &&
    e.target.classList.contains('js-qty__num')
  ) {
    e.preventDefault(); 
    return false;
  }
});
















